<template>
  <div>
    <div id="load_screen" v-if="loading">
      <div class="loader">
        <div class="loader-content">
<!--            add loader svg here-->
        </div>
      </div>
    </div>
    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      loading: true,
      loaded: false,
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      this.$store.commit('setUserLoading', true);
      this.$http.get('/auth/profile', {
        noAlert: true,
      })
        .then((res) => {
          this.$store.commit('setUser', res.body.data);
          this.$auth.setRole('caregiver');
          this.$acl.change('caregiver');
          if (res.body.data.roles.length > 0) {
            this.$role.setPermissions(res.body.data.roles[0].name, res.body.data.roles[0].permissions.map((permission) => permission.name));
          }
          this.loading = false;
          this.loaded = true;
          this.$store.commit('setUserLoading', false);
        })
        .catch(function () {
          this.loading = false;
          this.loaded = true;
          this.$store.commit('setUserLoading', false);
        });
    },
  },
};
</script>
